import React from 'react';
import {Col, Container, Row, Accordion} from "react-bootstrap";

function Question(props) {
    return (
        <div className={props.color ? 'services_question bg_color p-100' : 'services_question p-100'}>
            <Container>
                <Row>
                    <Col xs={12} md={12} lg={8} xl={8} xxl={8} className="question_title">
                        <div className="example" data-text="FAQs">
                            <h2>Frequently Asked Questions</h2>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="services_faqs">
                        <Accordion defaultActiveKey="0">
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>
                                    What is a digital strategy, and how can it benefit my business?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>A digital strategy is a plan that outlines how a business will use technology and
                                        digital channels to achieve its goals. A digital strategy can help businesses to
                                        identify and prioritize their digital initiatives, allocate resources
                                        effectively, and measure progress and success. A well-crafted digital strategy
                                        can help businesses stay ahead of the curve and remain competitive.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="1">
                                <Accordion.Header>
                                    What are the key components of a digital strategy?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>The key components of a digital strategy typically include situational analysis,
                                        a vision and mission statement, goals and objectives, and a roadmap for
                                        achieving those goals. Other components may include customer segmentation, a
                                        competitive analysis, and a budget and resource allocation plan.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="2">
                                <Accordion.Header>
                                    Can TekRevol help me develop a digital strategy for my business?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>Yes, TekRevol has a team of experienced professionals with expertise in digital
                                        strategy development. We have a successful history of helping businesses to
                                        identify and prioritize their digital initiatives, allocate resources
                                        effectively, and measure progress and success. Our team has the skills and
                                        knowledge to help you create a custom digital strategy that meets your specific
                                        needs and goals. Whether you're looking to improve your online presence,
                                        increase your sales, or better serve your customers, we can help you create a
                                        digital strategy that works for you.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="3">
                                <Accordion.Header>
                                    What does a digital strategy consultant do?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>A digital strategy consultant assists businesses create and apply digital strategies to accomplish their goals. They examine the market, opposition, and technology trends to counsel on digital transformation, marketing, and business development.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Question;